export default __webpack_public_path__ + "static/media/navigation-persistent.55a2c797.png";